<template>
  <el-radio-group v-model="formData[item.value]">
    <el-radio :style="{ width: items.labelSize }" v-for="items in item.children" :key="items.id" :label="items.value">
      <div class="u-relative" style="display: inline-block;">
        <div>{{ items.label }}</div>
        <div v-if="items.hasHit" class="hit-tag">
          <el-popover class="hit-tag" placement="top" width="400" trigger="hover" :content="items.hitText">
            <img slot="reference" src="@/assets/images/icon/hit.png" alt="hit">
          </el-popover>
        </div>
      </div>
    </el-radio>
  </el-radio-group>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.el-radio {
  flex-shrink: 0;
  margin-right: 0;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  line-height: 1.5;
}

.hit-tag {
  width: 20px;
  height: 20px;
  display: block;
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

::v-deep {
  .el-radio__inner {
    width: 20px;
    height: 20px;
    border-color: #bfbfbf;
  }

  .el-radio__label {
    font-size: 16px;
    color: #303133;
    // text-wrap: wrap;
    white-space: pre-wrap;
  }

  .el-form-item__error {
    padding-left: 20px;
  }
}
</style>